'use client';

import { Button, buttonVariants } from '@/components/ui/button';
import { getMultidietPopup } from '@/features/multidiet-picker/api/get-cms-popup';
import { MultidietPickerPopup } from '@/features/multidiet-picker/components/multidiet-picker-popup';
import { cn } from '@/lib/utils';
import { IconArrowNarrowRight } from '@tabler/icons-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

type MultidietCtaButtonProps = {
  buttonLabel?: string;
  testId?: string;
  children?: React.ReactNode;
};

export const MultidietCtaButton = ({
  buttonLabel,
  testId = '',
  children,
}: MultidietCtaButtonProps) => {
  const [open, setOpen] = useState(false);
  const t = useTranslations('staticBuilder.multidiet');

  return (
    <MultidietPickerPopup setOpen={setOpen} open={open}>
      {children || (
        <Button
          onClick={() => setOpen(true)}
          className={cn(
            buttonVariants({
              className: 'px-6 py-3 max-md:w-full',
            }),
          )}
          data-pw={testId}
        >
          <span>{buttonLabel || t('cta')}</span>
        </Button>
      )}
    </MultidietPickerPopup>
  );
};
